import React from 'react';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-800 text-white py-2 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <p className="text-sm">
            Freight Management System by CLAPOTIS
          </p>
          <p className="text-xs text-gray-300 mt-1">
            © 2020-{currentYear} All Rights Reserved
          </p>
        </div>
      </div>
    </footer>
  );
};
